export type AllocationFrequency = "once" | "twice" | "thriceOrMore"

export const ALLOCATION_FREQUENCY_LABELS: Record<AllocationFrequency, string> = {
  once: "年1回",
  twice: "年2回",
  thriceOrMore: "年3回以上",
}

// 割当実施回数そのものを表すフィールドは公式ページに明記されないことが多く、
// クロール時にAIが抽出するrecordMonths(権利確定月)の件数から近似する。
// 権利確定日ごとにその時点の株主へ優待が割り当てられるのが一般的なため、
// 記録された確定月の個数がそのまま年間の割当回数に一致することが多い。
export function allocationFrequencyFromRecordMonths(
  recordMonths: number[]
): AllocationFrequency | null {
  if (recordMonths.length === 0) return null
  if (recordMonths.length === 1) return "once"
  if (recordMonths.length === 2) return "twice"
  return "thriceOrMore"
}
